exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".float-wrapper[data-v-3b305e1c]{position:relative}.form-label[data-v-3b305e1c]{margin:0;font-size:14px;font-weight:700}.float-wrapper .form-label[data-v-3b305e1c]{position:absolute;left:.5rem;top:.875rem;transform:translateY(0);background-color:transparent;padding:0 .25rem;transition:.2s ease-out;pointer-events:none;line-height:1;border-radius:2px;opacity:.5}.float-wrapper.float-label .form-label[data-v-3b305e1c]{font-size:12px;top:0;left:.25rem;opacity:1;background-color:#fff;transform:translateY(-50%)}", ""]);

// exports
